import { useSelector } from "react-redux";

import { DataTable } from "../../../components/DataTable";
import { setBillingsListPagination, setBillingsListScrollTop } from "../../../reducers/billingsReducer";
import {
  getBillings,
  getBillingsList,
  getBillingsListScrollTop,
  getIsBillingsListStatusLoading,
} from "../../../selectors/billings";
import { useGetBillingsTableColumns } from "./useGetBillingsTableColumns";
import { useGetBillingsTableHandlers } from "./useGetBillingsTableHandlers";

import styles from "./BillingsTable.module.scss";

export const BillingsTable: React.FC = () => {
  const data = useSelector(getBillingsList);
  const columns = useGetBillingsTableColumns();
  const isLoading = useSelector(getIsBillingsListStatusLoading);
  const scrollTop = useSelector(getBillingsListScrollTop);
  const billingsState = useSelector(getBillings);
  const { handleAdditionalRowClick } = useGetBillingsTableHandlers();

  return (
    <DataTable
      className={styles.container}
      dataRows={data}
      columns={columns}
      scrollTop={scrollTop}
      setScrollTop={setBillingsListScrollTop}
      setPagination={setBillingsListPagination}
      isLoading={isLoading}
      sliceState={billingsState}
      handleAdditionalRowClick={handleAdditionalRowClick}
    />
  );
};
